import { ObjectiveConfig } from './objective-config.js';
import { TeamState } from './team.js';
import { BonusPenaltyT } from './bonus-penalty-t.js';
import { BonusPenalty } from './bonus-penalty.js';

export abstract class ObjectiveBonusPenalty<T> extends BonusPenaltyT<T> {
    constructor(
        team: TeamState,
        public config: ObjectiveConfig,
        valid: boolean,
        awarded: Date,
        public index: number
    ) {
        super(team, valid, awarded);
        if (!this.config) {
            throw new Error(`ObjectiveConfig is required for ${this.constructor.name}`);
        }
    }
    equals(other: BonusPenalty): boolean {
        if (!(other instanceof ObjectiveBonusPenalty)) {
            return false;
        }
        const otherConfig = (<ObjectiveBonusPenalty<T>>other).config;
        return (
            this.team.id === other.team.id &&
            this.config.name === otherConfig.name &&
            this.valid === other.valid &&
            this.awarded.getTime() === other.awarded.getTime()
        );
    }
}
